import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { AgGrid } from '../../../../../../components'
import { getDefaultColumnDef } from '../../../../../../utils'
import CustomCellRender from './cell/cell.component'

class FundListComponent extends PureComponent {

  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      columns: [
        { typeOfValue: 'text', field: 'fund_name', headerName: 'Fund Name', minWidth: 260 },
        { typeOfValue: 'text', field: 'address', headerName: 'Location', minWidth: 230, maxWidth: 260 },
        { typeOfValue: 'text', field: 'style', headerName: 'Style', minWidth: 140, maxWidth: 160 },
        { typeOfValue: 'number', field: 'portfolio_value', headerName: 'AUM ($MM)', minWidth: 100, maxWidth: 120 }
      ]
    }
  }

  /**
   * Handle AgGrid onGridReady event
   * @param grid
   * @see: {@link: https://github.com/ag-grid/ag-grid/issues/997}
   */
  handleGridReady = (grid) => {
    setTimeout(() => this.agGrid = grid, 0)
  }

  /**
   * Handle AgGrid gridSizeChanged event
   * @param type - event type
   */
  handleGridResize = ({ type }) => {
    if (type === 'gridSizeChanged') {
      setTimeout(() => this.agGrid && this.agGrid.api.sizeColumnsToFit(), 0)
    }
  }

  /**
   * Handle page change
   * @param selected
   */
  handlePageChange = ({ selected }) => {
    const { handleFilterChange } = this.props
    handleFilterChange({ page: selected })
  }

  /**
   * Handle page size change
   * @param selected
   */
  handlePageSizeChange = ({ selected }) => {
    const { handleFilterChange } = this.props
    handleFilterChange({ page: 1, limit: selected })
  }

  /**
   * Returns grid columns
   */
  getColumnsDefinition = () => {
    return this.state.columns.map(({ typeOfValue, ...column }, idx) => ({
      ...getDefaultColumnDef(idx, typeOfValue),
      ...column
    }))
  }

  /**
   * Renders CustomCell Component
   */
  renderCustomCell = (props) => {
    return (<CustomCellRender {...props} />)
  }

  render () {
    const { data, filters: { page, limit }, total } = this.props

    return (

      <AgGrid
        className='data-table funds-grid'
        domLayout='autoHeight'
        sizeToFit={true}

        // suppress configs
        suppressMovableColumns={true}
        suppressContextMenu={true}

        // columns and data
        defaultColDef={{
          suppressMenu: true,
          sortable: false,
          cellRenderer: 'CustomCellRender'
        }}
        columnDefs={this.getColumnsDefinition()}
        rowData={data.slice((page - 1) * limit, (page - 1) * limit + limit)}

        // custom components
        frameworkComponents={{
          CustomCellRender: this.renderCustomCell
        }}

        // pagination
        pagination={true}
        paginationProps={{
          pageSizeId: 'contact-fund-list',
          forcePage: page,
          initialPageSize: limit,
          showPageSizeSelection: true,
          total,
          onPageChange: this.handlePageChange,
          onPageSizeChange: this.handlePageSizeChange
        }}

        // event listeners
        onGridReady={this.handleGridReady}
        onGridSizeChanged={this.handleGridResize}
      />
    )
  }
}

FundListComponent.propTypes = {
  data: PropTypes.array.isRequired,
  handleFilterChange: PropTypes.func,
  filters: PropTypes.object
}

FundListComponent.defaultProps = {
  data: [],
  total: 0,
  filter: {
    page: 1,
    limit: 10
  }
}

export default FundListComponent